module.exports = __webpack_public_path__ + "images/liinilaevad/routes/NAR-NAJ-NAR@3x.png";